/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import eventemitter2 from 'eventemitter2';

/**
 * @fileoverview Injectable wrapper for EventEmitter2 library.
 * {https://github.com/asyncly/EventEmitter2}
 */
angular.module('aviApp').factory('EventEmitter2', function() {
    return eventemitter2;
});
